import * as React from 'react';
import IndexTableRow from '@lib/components/index-table/IndexTableRow'
import {observer} from 'mobx-react';
import IndexTableHeading from './IndexTableHeading';
import IndexTableFeature from './IndexTableFeature';

const IndexTableDefaultFeatures = [
    IndexTableFeature.ActionButtons,
    IndexTableFeature.NamesAsEditPageLinks
]

const IndexTable = observer(
    class IndexTable extends React.Component {
        rowComponentClass = IndexTableRow

        state = {
            sort: {},
            manuallyChangedRows: {},
            isRootCheckboxChecked: false
        }

        static defaultProps = {
            features: IndexTableDefaultFeatures,
            keyName: 'id'
        }

        //static Feature = IndexTableFeature;
        //static defaultFeatures = IndexTableDefaultFeatures

        constructor(props) {
            super(props)
            this.props.results.map(x => {
                this.state.manuallyChangedRows[x.id] = false
            })

            this.getRowComponentProps = this.getRowComponentProps.bind(this);
        }

        componentDidUpdate(prevProps) {
            this.updateManuallyChangedRowsAfterDeleteBatch(prevProps)
        }

        updateManuallyChangedRowsAfterDeleteBatch(prevProps) {
            if (prevProps.results.length === this.props.results.length)
                return;

            var ids = this.props.results.map(x => x.id)
            var updatedManuallyChangedRows = {}
            for (let [k, v] of Object.entries(this.state.manuallyChangedRows)) {
                if (ids.indexOf(k) > -1) {
                    updatedManuallyChangedRows[k] = v
                }
            }

            this.setState({
                manuallyChangedRows: updatedManuallyChangedRows
            })
        }

        onRootCheckboxToggled = e => {
            let manuallyChangedRows = this.state.manuallyChangedRows
            for (let [k, v] of Object.entries(manuallyChangedRows)) {
                manuallyChangedRows[k] = !this.state.isRootCheckboxChecked
            }

            this.setManuallyChangedRows(manuallyChangedRows, !this.state.isRootCheckboxChecked, () => {
                if (!this.props.onRootCheckboxToggled)
                    return;

                if (!this.state.isRootCheckboxChecked) {
                    this.props.onRootCheckboxToggled(manuallyChangedRows)
                } else {
                    this.props.onRootCheckboxToggled({})
                }
            })
        }

        setManuallyChangedRows(selected, isRootCheckboxChecked, callback = () => {
        }) {
            this.setState(prev => {
                return {
                    isRootCheckboxChecked: isRootCheckboxChecked,
                    manuallyChangedRows: selected
                }
            }, callback())
        }

        onRowCheckboxToggled = id => {

            if (this.isMutliSelectTable())
                this.onMultiSelectRowCheckboxToggled(id);
            else
                this.onSingleSelectRowCheckboxToggled(id);

        }

        onSingleSelectRowCheckboxToggled = id => {

            let manuallyChangedRows = this.state.manuallyChangedRows

            if (typeof manuallyChangedRows[id] !== 'undefined') {
                manuallyChangedRows[id] = !manuallyChangedRows[id]
            } else {
                manuallyChangedRows[id] = true
            }

            //clean up  rest of them
            for (let [k, v] of Object.entries(manuallyChangedRows)) {
                if (k != id)
                    manuallyChangedRows[k] = false;
            }
            let currentRow = {};
            if (manuallyChangedRows[id])
                currentRow = this.props.results.filter(r => r.id == id)


            let checkedRows = 0
            for (let v of Object.values(manuallyChangedRows)) {
                if (v) checkedRows++
            }

            this.setManuallyChangedRows(manuallyChangedRows, checkedRows === this.props.results.length, () => {
                if (this.props.onRowCheckboxToggled)
                    this.props.onRowCheckboxToggled(currentRow)
            })
        }


        onMultiSelectRowCheckboxToggled = id => {

            let manuallyChangedRows = this.state.manuallyChangedRows

            if (typeof manuallyChangedRows[id] !== 'undefined') {
                manuallyChangedRows[id] = !manuallyChangedRows[id]
            } else {
                manuallyChangedRows[id] = true
            }

            let checkedRows = 0
            for (let v of Object.values(manuallyChangedRows)) {
                if (v) checkedRows++
            }

            this.setManuallyChangedRows(manuallyChangedRows, checkedRows === this.props.results.length, () => {
                if (this.props.onRowCheckboxToggled)
                    this.props.onRowCheckboxToggled(manuallyChangedRows)
            })
        }

        hasRowCheckbox = () => this.props.options.hasRowCheckbox;

        isMutliSelectTable() {
            if (!this.hasRowCheckbox())
                return false;

            return this.props.multiSelectRows ? this.props.multiSelectRows() : true;
        }

        isSortableColumn = (slug) => {
            let orderOptions = this.props.orderOptions || [];

            let is = orderOptions.find(f => f.slug == slug);

            return is != undefined;
        }

        onSortChange = column => {
            let sort = this.state.sort
            let slug = column.slug
            let direction = ''

            if (!this.isSortableColumn(slug))
                return;

            if (this.isColumnSortActive(column)) {
                if (this.state.sort[slug] === 'ascending') {
                    direction = 'descending'
                } else {
                    direction = 'ascending'
                }
                sort[slug] = direction
            } else {
                sort = {};
                direction = 'ascending'
                sort[slug] = direction;
            }

            this.setState({
                sort: sort
            })

            this.props.onSortChange(column, direction)
        }

        render() {
            return (
                <React.Fragment>
                    <div className="index-table-actions">
                        {this.renderTableActions()}
                    </div>
                    {this.renderTable()}
                </React.Fragment>
            )
        }

        renderTableActions = () => (
            <React.Fragment/>
        )

        renderTable = () => {
            let rootCheckboxVisible = this.isMutliSelectTable();
            const RowComponent = this.rowComponentClass
            const {options} = this.props
            const columns = this.props.columns.filter(x => x.visible)
            const rootCheckboxId = 'root-checkbox-' + Math.random();

            return (
                <table className="index-table">
                    <thead>
                    <tr>
                        {rootCheckboxVisible && <th className="table-checkbox-column">
                            <input id={rootCheckboxId} type="checkbox" onChange={this.onRootCheckboxToggled}
                                   checked={this.state.isRootCheckboxChecked}/>
                            <label htmlFor={rootCheckboxId}></label>
                        </th>}

                        {columns.map((column, idx) => (
                            <IndexTableHeading
                                key={idx}
                                column={column}
                                sortActive={this.isColumnSortActive(column)}
                                sortDirection={this.isColumnSortActive(column) ? this.getColumnSortDirection(column) : ''}
                                onClick={this.isSortableColumn(column.slug) ? () => this.onSortChange(column) : undefined}
                            />
                        ))}

                        {this.isFeatureRequested(IndexTableFeature.ActionButtons) && (
                            <th>{__('Actions')}</th>
                        )}
                    </tr>
                    </thead>

                    <tbody>
                    {this.props.results.map(result => (
                        <React.Fragment key={result[this.props.keyName]}>
                            {this.renderBeforeRow(result, columns)}
                            <RowComponent {...this.getRowComponentProps(result, columns, options)} />
                            {this.renderAfterRow(result, columns)}
                        </React.Fragment>

                    ))}
                    </tbody>
                    {this.renderTableFoot()}
                </table>
            )
        }

        renderBeforeRow(result, columns) {
            return <React.Fragment/>
        }

        renderAfterRow(result, columns) {
            return <React.Fragment/>
        }

        renderTableFoot() {
            return <React.Fragment/>
        }

        getRowComponentProps(result, columns, options) {
            return {
                key: result[this.props.keyName],
                isRootCheckboxChecked: this.state.isRootCheckboxChecked,
                columns: columns.filter(x => x.visible),
                row: result,
                rows: this.props.results,
                actionButtons: this.getActionButton(options.rowButtons),
                allowNamesAsEditPageLinks: this.isFeatureRequested(IndexTableFeature.NamesAsEditPageLinks),
                isChecked: this.shouldRowBeChecked(result),
                onCheckboxChanged: this.onRowCheckboxToggled,
                onRemoveRowClick: this.props.onRemoveRowClick,
                onCopyRowClick: this.props.onCopyRowClick,
                hasRowCheckbox: this.props.options.hasCheckboxColumn,
                onReloadCall: this.props.onReloadCall,
            }
        }

        getActionButton = rowButtons => {
            var hasButtonActions = this.isFeatureRequested(IndexTableFeature.ActionButtons);
            var hasNameAsLink = this.isFeatureRequested(IndexTableFeature.NamesAsEditPageLinks);

            if (!hasButtonActions && hasNameAsLink) {
                return rowButtons.filter(x => x.Slug !== 'Edit');
            } else if (!hasButtonActions) {
                return []
            } else {
                return rowButtons
            }
        }

        shouldRowBeChecked = result => {
            if (typeof this.state.manuallyChangedRows[result.id] !== 'undefined') {
                return this.state.manuallyChangedRows[result.id]
            }

            return this.state.isRootCheckboxChecked
        }

        isColumnSortActive = column => {
            return typeof this.state.sort[column.slug] !== 'undefined'
        }

        getColumnSortDirection = column => {
            return this.state.sort[column.slug]
        }

        isFeatureRequested = feature => {
            return this.props.features.includes(feature);
        }
    }
)

export default IndexTable